module.exports = __webpack_public_path__ + "img/snowball.a67274d6.png";